export const preloaderColorStyle = { 
    color: '#DC7F0A'
}